import { render, staticRenderFns } from "./CashRecord.vue?vue&type=template&id=84c32c62&scoped=true"
import script from "./CashRecord.vue?vue&type=script&lang=js"
export * from "./CashRecord.vue?vue&type=script&lang=js"
import style0 from "./CashRecord.vue?vue&type=style&index=0&id=84c32c62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c32c62",
  null
  
)

export default component.exports